(function () {
    $('document').ready(function () {
        // Prevent default for empty links
        $('[href="#"]').click(function (e) {
            e.preventDefault();
        });

        // Adding data-parent to togglable nav items
        $('#sidenav [data-toggle]').each(function () {
            $(this).attr('data-parent', '#' + $(this).parent().parent().attr('id'));
        });

        // Trigger window resize to update nvd3 charts
        $('[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            window.dispatchEvent(new Event('resize'));
        });

        $('input[type="tel"]').on('keyup', function () {
            this.value = this.value.replaceAll(' ', '')
                .trimLeft('0')
                .trimLeft('+90')
                .trimLeft('90');
        });

        $('input[name="vehicle_plate_number"], input[name="vehicle_chassis_number"]').on('keyup', function () {
            this.value = this.value.replaceAll(' ', '').upperCase();
        });

        // Activate animated progress bar
        $('.bd-toggle-animated-progress').on('click', function () {
            $(this).siblings('.progress').find('.progress-bar-striped').toggleClass('progress-bar-animated')
        });

        // Fix code block indentations
        $('code').each(function () {
            var lines = $(this).html().split('\n');
            if (lines[0] === '') {
                lines.shift();
            }

            var matches;
            const indentation = (matches = /^\s+/.exec(lines[0])) !== null ? matches[0] : null;
            if (!!indentation) {
                lines = lines.map(function (line) {
                    return line.replace(indentation, '');
                });

                $(this).html(lines.join('\n').trim());
            }
        });

        // Flip source-preview cards
        $('.toggle-source-preview').on('click', function () {
            $(this).parents('.example').toggleClass('show-source');
        });
    });

    /**
     * Watching media step changes
     */
    /*$(window).on('fuse::matchMediaChanged', function (ev, currentStep, isOrBelow, isOrAbove)
     {
     console.info('match media changed');
     console.info(currentStep);
     });*/


    const queryBlock = $('.queryBlock');
    if (queryBlock.length > 0) {
        queryBlock.each(function () {
            const type = $(this).attr('data-type');
            const id = $(this).attr('data-id');
            const status = $(this).attr('data-status');

            if (status === '0') {
                const channel = Echo.channel(echoChannelNamePrefix() + '.api.vehicleApi.' + type + '.' + id);
                channel.listen('.status-change', function (model) {
                    model = JSON.parse(model);
                    if (model.status !== status) {
                        window.location.reload();
                    }
                });
            }
        });
    }

    document.actionButton = {
        itemDeleteConfirm: function (route, id) {
            $('#itemDeleteModal form').attr('action', route);
            $('#itemDeleteModal .modal-body span').html(id);
            $('#itemDeleteModal').modal();
        },

        itemForceDeleteConfirm: function (route, id) {
            $('#itemForceDeleteModal form').attr('action', route);
            $('#itemForceDeleteModal .modal-body span').html(id);
            $('#itemForceDeleteModal').modal();
        },

        itemForceDeleteWithoutIdConfirm: function (route) {
            $('#itemForceDeleteModalWithoutId form').attr('action', route);
            $('#itemForceDeleteModalWithoutId').modal();
        },

        itemRestoreConfirm: function (route, id) {
            $('#itemRestoreModal form').attr('action', route);
            $('#itemRestoreModal .modal-body span').html(id);
            $('#itemRestoreModal').modal();
        },

        passwordResetConfirm: function (route, id) {
            $('#passwordResetModal form').attr('action', route);
            $('#passwordResetModal .modal-body span').html(id);
            $('#passwordResetModal').modal();
        }
    }
})();
